module.exports = __webpack_public_path__ + "media/images/logo-header-beta-c8f7fd4110f091ae3832a40f8ed19fb0.png";